import { atom } from 'jotai'
import { atomWithReset } from 'jotai/utils'
import type { SelectedSpot } from './types'
import type { Dayjs } from 'dayjs'
import { getBookingDefaultDate } from '../../../components/Datepicker/utils/utils'

export const selectedBeachPlanIdAtom = atom<string>('')

export const selectedSpotsAtom = atom<SelectedSpot[]>([])

const selectedDateBaseAtom = atom<Dayjs | null>(null)

export const selectedDateAtom = atom(
  (get) => get(selectedDateBaseAtom) ?? getBookingDefaultDate(),
  (get, set, update: Dayjs | ((prev: Dayjs) => Dayjs)) => {
    const current = get(selectedDateAtom)
    const nextValue = typeof update === 'function' ? update(current) : update
    set(selectedDateBaseAtom, nextValue)
  }
)

export const bookingIdAtom = atomWithReset<string>('')
